import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { FormStatusRouter } from './form-status.router';
import { reducers } from './state/form-status.selectors';

@NgModule({
  imports: [
    CommonModule,
    FormStatusRouter,
    StoreModule.forFeature('formStatus', reducers),
  ],
  declarations: []
})
export class FormStatusScreenModule { }